import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';

import { createReducer } from 'utils/redux';

import type { FacebookButtonAction, FacebookButtonState } from '../types';

const EMPTY_STATE: FacebookButtonState = {
  isFBLoginActive: false,
  isFBLoginExpired: false,
  authResponse: null,
  modalType: null,
  instagramUserName: null,
  error: null
};

const initialState = cloneDeep(EMPTY_STATE);

export default createReducer<FacebookButtonState, FacebookButtonAction>(
  'facebookButton',
  initialState,
  {
    'facebook-button-login': (state, { instagramUserName }) => produce(
      state, draft => {
        draft.isFBLoginActive = true;
        draft.isFBLoginExpired = false;
        draft.instagramUserName = instagramUserName;
      }
    ),
    'facebook-button-expire-token': state => produce(
      state, draft => {
        draft.isFBLoginExpired = true;
      }
    ),
    'facebook-button-logout': state => produce(
      state, draft => {
        draft.isFBLoginActive = false;
      }
    ),
    'facebook-button-save-response': (state, { authResponse }) => produce(
      state, draft => {
        draft.authResponse = authResponse;
      }
    ),
    'facebook-button-update-modal-type': (state, { modalType }) => produce(
      state, draft => {
        draft.modalType = modalType;
      }
    ),
    'facebook-button-dialog-error': (state, { error }) => produce(
      state, draft => {
        draft.error = error;
      }
    ),
    'facebook-button-flush-state': state => produce(
      state, draft => {
        const nextState = cloneDeep(EMPTY_STATE);
        const keys = Object.keys(nextState);

        keys.forEach(key => {
          draft[key] = nextState[key];
        });
      }
    )
  }
);
